module.exports = __webpack_public_path__ + "bdabd6f6f4a089c13ddf78dabb624b47.svg";


//////////////////
// WEBPACK FOOTER
// ./spa/images/icons/plus_19_disabled.svg
// module id = 1195
// module chunks = 65